import React from 'react';
import { withTranslation, WithTranslation } from '@wix/wix-i18n-config';
import s from './Price.scss';
import {
  isLocalCurrencyOnRight,
  isLocalCyrillic,
} from '../../services/window-utils';
import classNames from 'classnames';
import { formatNumber } from '../../constants';
import { data } from '../../globals';

export interface PriceProps extends WithTranslation {
  amount: number;
  currency: string;
  discountAmount?: number;
  narrowView?: boolean;
}

class Price extends React.Component<PriceProps> {
  render() {
    const { t, amount, discountAmount, currency } = this.props;
    const { decimalSeparator, groupSeparator } = data.currency;
    const amountWithSeparators = formatNumber(
      amount,
      decimalSeparator,
      groupSeparator,
    );
    const rightCurrency = isLocalCurrencyOnRight() ? currency : null;
    const leftCurrency = !isLocalCurrencyOnRight() ? currency : null;
    const formattedAmount = isLocalCurrencyOnRight()
      ? `${amountWithSeparators} ${currency}`
      : `${currency} ${amountWithSeparators}`;

    return (
      <div className={s.root} data-hook="price-component">
        <div className={s.price} data-hook="price">
          <div className={s.currencyLeft} data-hook="price-currency-left">
            {leftCurrency}
          </div>
          <div
            className={classNames(s.amount, {
              [s.isLocalCyrillic]: isLocalCyrillic(),
            })}
            data-hook="price-amount"
          >
            {discountAmount ? discountAmount : amountWithSeparators}
          </div>
          <div className={s.currencyRight} data-hook="price-currency-right">
            {rightCurrency}
          </div>
        </div>
        <div className={s.bottomData}>
          <div
            className={classNames(s.discountPrice, {
              [s.narrowView]: this.props.narrowView,
            })}
            data-hook="price-original"
          >
            {discountAmount ? formattedAmount : null}
          </div>
          <div className={s.aMonth} data-hook="price-aMonth">
            {t('package.aMonth')}
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(Price);
